webpackJsonp([114276838955818],{

/***/ 172:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarketTapProductCategory":{"edges":[{"node":{"id":"6","slug":"planning","name":"Planning"}},{"node":{"id":"7","slug":"social-media","name":"Social Media"}},{"node":{"id":"8","slug":"content-writing","name":"Content Writing"}},{"node":{"id":"9","slug":"photo-video","name":"Photo / Video"}},{"node":{"id":"10","slug":"graphic-design","name":"Graphic Design"}},{"node":{"id":"11","slug":"packages","name":"Packages"}}]}},"layoutContext":{}}

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(559);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(172);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _class, _temp;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding-top: 80px;\n  '], ['\n    padding-top: 80px;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(98);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _shared = __webpack_require__(7);
	
	var _jsCookie = __webpack_require__(50);
	
	var _styles = __webpack_require__(6);
	
	var _cart = __webpack_require__(19);
	
	var _marketerSessions = __webpack_require__(109);
	
	var _guestCartCookieName = __webpack_require__(44);
	
	var _guestCartCookieName2 = _interopRequireDefault(_guestCartCookieName);
	
	__webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'layouts__Wrapper'
	})(['font-weight:500;color:', ';-webkit-font-smoothing:antialiased;padding-top:60px;', ';'], _styles.theme.colors.navy, _styles.media.ldesktop(_templateObject));
	
	var TemplateWrapper = (_temp = _class = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper() {
	    _classCallCheck(this, TemplateWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TemplateWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!(0, _jsCookie.get)(_guestCartCookieName2.default)) {
	      this.props.onCreateCart();
	    }
	    if ((0, _jsCookie.get)(_guestCartCookieName2.default)) {
	      this.props.onFetchCart((0, _jsCookie.get)(_guestCartCookieName2.default));
	    }
	    this.props.onFetchMarketerSessions();
	  };
	
	  TemplateWrapper.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        allMarketTapProductCategory = _props.data.allMarketTapProductCategory;
	
	    var productCategories = allMarketTapProductCategory.edges.map(function (e) {
	      return e.node;
	    });
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'On Demand Marketing Services | Hire a Marketer | MarketTap',
	        meta: [{
	          name: 'description',
	          content: 'MarketTap is a simple marketing platform that sells on-demand marketing services. We specialize in helping small businesses sell more online. Purchase from our a la carte marketing services today.'
	        }, {
	          name: 'keywords',
	          content: 'marketing, social, copywriting, video production'
	        }, {
	          name: 'viewport',
	          content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
	        }]
	      }),
	      _react2.default.createElement(_shared.FlashMessage, null),
	      _react2.default.createElement(_shared.TopBar, { productCategories: productCategories }),
	      _react2.default.createElement(_shared.NavDrawer, { productCategories: productCategories }),
	      _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: _styles.theme },
	        children()
	      ),
	      _react2.default.createElement(_shared.Footer, { productCategories: productCategories }),
	      ("production") === 'development' && _react2.default.createElement(_shared.BreakpointDisplay, null)
	    );
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component), _class.propTypes = {
	  onCreateCart: _propTypes2.default.func.isRequired,
	  onFetchCart: _propTypes2.default.func.isRequired,
	  onFetchMarketerSessions: _propTypes2.default.func.isRequired,
	  children: _propTypes2.default.func.isRequired,
	  data: _propTypes2.default.shape({ allMarketTapProductCategory: _propTypes2.default.object }).isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = {
	  onCreateCart: _cart.createCart,
	  onFetchCart: _cart.fetchCart,
	  onFetchMarketerSessions: _marketerSessions.fetch
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TemplateWrapper);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-ff02dcf4c0cd3f187069.js